import { render, staticRenderFns } from "./Lunbo.vue?vue&type=template&id=73980658&scoped=true&"
import script from "./Lunbo.vue?vue&type=script&lang=js&"
export * from "./Lunbo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73980658",
  null
  
)

export default component.exports